// extracted by css-extract-rspack-plugin
export default {"selector":"selector-GwWRfb"};